<template>
  <div class="document-icd-codes-tab-container">
    <div class="position-absolute w-100 h-100">
      <div class="overflow-auto w-100" style="height: calc(100% - 50px)">
        <div
          v-for="code in diagnosisCodes"
          :key="code.id"
          class="d-flex flex-column mx-2 mb-4"
        >
          <div class="d-flex flex-row align-items-center">
            <b-badge variant="primary" class="text-white mr-1 p-1"
              >{{ code.category[0] }}
            </b-badge>
            <div class="icd-code-title">{{ code.icdCode.code }}</div>
            <span
              class="badge-v2 badge-warning px-4 ml-1 text-white badge-fixed-size icd-code-badge"
              :style="{ background: code.status.color }"
            >
              {{ code.status.name }}
            </span>
            <div class="ml-auto" v-show="!disableControls">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                v-if="!readonly"
              >
                <template #button-content>
                  <i
                    class="fa fa-ellipsis-v color-custom-dark-grey hover-text-primary b-action-item grid-action-icon"
                  >
                  </i>
                </template>
                <b-dropdown-item-button @click="editIcdCode(code)"
                  >Edit</b-dropdown-item-button
                >
                <b-dropdown-item-button @click="deleteIcdCode(code)"
                  >Delete</b-dropdown-item-button
                >
              </b-dropdown>
            </div>
          </div>
          <div class="my-1 icd-code-description">
            {{ code.icdCode.description }}
          </div>
          <div v-if="code.activeFrom" class="my-1 icd-code-content">
            Active from: {{ formatDate(code.activeFrom) }}
          </div>
          <div v-if="code.resolvedBy" class="my-1 icd-code-content">
            Resolved by: {{ formatDate(code.resolvedBy) }}
          </div>
          <div v-if="code.description" class="my-1 icd-code-content">
            <b>Comments:</b>
            <br />
            <span>{{ code.description }}</span>
          </div>
        </div>
      </div>
      <div
        class="d-flex justify-content-center align-items-center"
        style="height: 50px"
      >
        <b-button
          :disabled="readonly || disableControls"
          variant="primary"
          @click="addDiagnosisCode"
        >
          Add ICD Code
        </b-button>
      </div>
    </div>
    <eoc-view-add-edit-diagnosis-codes-modal
      v-if="showIcdCodeModal"
      v-model="showIcdCodeModal"
      :diagnosisCodeId="diagnosisCodeId"
      :eocId="eocId"
      :patientId="patientId"
      @onModify="onDiagnosisCodeModify"
    />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import diagnosisCodesServer from "../../../server/diagnosisCode";
import scheduleEventServer from "../../../server/scheduleEvent";
import { formatDateOnly } from "../../../helpers/date";
import EocViewAddEditDiagnosisCodesModal from "../EocViewAddEditDiagnosisCodesModal.vue";

export default {
  name: "DocumentIcdCodesTabContent",
  components: {
    EocViewAddEditDiagnosisCodesModal
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    eocId: {
      type: String
    },
    patientId: {
      type: String
    },
    scheduleEventId: {
      type: String
    }
  },
  data() {
    return {
      diagnosisCodes: [],
      showIcdCodeModal: false,
      diagnosisCodeId: null,
      encounterSubmited: false
    };
  },
  mounted() {
    this.getDiagnosisCodes();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async getDiagnosisCodes() {
      this.diagnosisCodes = await diagnosisCodesServer.query(false, this.eocId);
      let prymaryCategory = this.diagnosisCodes
        .filter(x => x.category == "Primary")
        .sort((a, b) => a.icdCode.code.localeCompare(b.icdCode.code));
      let secundaryCategory = this.diagnosisCodes
        .filter(x => x.category == "Secondary")
        .sort((a, b) => a.icdCode.code.localeCompare(b.icdCode.code));
      let tertiaryCategory = this.diagnosisCodes
        .filter(x => x.category == "Tertiary")
        .sort((a, b) => a.icdCode.code.localeCompare(b.icdCode.code));
      this.diagnosisCodes = [
        ...prymaryCategory,
        ...secundaryCategory,
        ...tertiaryCategory
      ];
      if (this.scheduleEventId != null) {
        const scheduleEvent = await scheduleEventServer.get(
          this.scheduleEventId
        );
        this.encounterSubmited = scheduleEvent.billingInfo?.encounterSubmited;
      }
    },
    editIcdCode(diagnosisCode) {
      this.diagnosisCodeId = diagnosisCode.id;
      this.showIcdCodeModal = true;
    },
    deleteIcdCode(diagnosisCode) {
      this.$dialog
        .alert(
          {
            title: "Are you sure you want to delete this record?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          await diagnosisCodesServer.delete(diagnosisCode.id);
          this.getDiagnosisCodes();
          this.showAlertSuccess();
          this.$emit("onChange", {
            isDelete: true,
            id: diagnosisCode.id
          });
        });
    },
    formatDate(date) {
      return formatDateOnly(date);
    },
    onDiagnosisCodeModify(icdCodeChange) {
      this.showIcdCodeModal = false;
      this.getDiagnosisCodes();
      this.$emit("onChange", icdCodeChange);
    },
    addDiagnosisCode() {
      this.diagnosisCodeId = null;
      this.showIcdCodeModal = true;
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser
    }),

    ...mapGetters("layout", [
      "getCurrentAdjustedDateTime",
      "hasCurrentUserPermissionAccess"
    ]),
    disableControls() {
      return (
        this.encounterSubmited &&
        !this.hasCurrentUserPermissionAccess("others", "editChargedEvents")
      );
    }
  },
  watch: {
    // async documentId(newValue) {
    //   await this.getNotes(newValue);
    // }
  }
};
</script>

<style scoped>
.document-icd-codes-tab-container {
  position: relative;
  flex-grow: 1;
  width: 100%;
  height: 100%;
}
.icd-code-title {
  font-size: 1.15rem;
  font-weight: 700;
}
.icd-code-badge {
  max-height: 30px;
  padding-top: 2px;
  padding-bottom: 2px;
}
.icd-code-description {
  font-size: 0.95rem;
}
.icd-code-content {
  font-size: 0.9rem;
}
</style>
